module.exports = __webpack_public_path__ + "static/media/new-blue-logo.378c5d91.svg";